import React from 'react';

const YouTubeHelpButton = ({ url, text }) => {
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      className="group flex items-center justify-center gap-3 p-4 mt-6 rounded-2xl border-2 border-red-100 bg-red-50/30 hover:bg-red-50 hover:border-red-300 transition-all duration-300 shadow-sm hover:shadow-md"
    >
      {/* YouTube Icon SVG */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 text-red-600 group-hover:scale-110 transition-transform">
        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
      </svg>
      
      <div className="text-left">
         <p className="text-[10px] text-red-500 font-bold uppercase tracking-wider">Need Help?</p>
         <p className="text-slate-800 font-extrabold text-lg group-hover:text-red-700 transition-colors">{text}</p>
      </div>
    </a>
  );
};

export default YouTubeHelpButton;